import type { ChartPayload } from './types'

export const emptyChartsPayload: ChartPayload = {
  wealth: [],
  cashflow: [],
  milestones: [],
  isEmpty: true,
}
